export default __webpack_public_path__ + "static/media/seo-blog17.4611bab7.jpg";